module.exports = __webpack_public_path__ + "img/ralts00.396c1930.jpeg";